import {getService, getServiceAuthorized, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized, putServiceAuthorized} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';

const NotificationService = {};

NotificationService.allNotifications = (pgNo,limit,action, token) => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/notification/get/notification/by/contactId?pageNo=${pgNo}&limit=${limit}&action=${action}`,
    token,
  )

NotificationService.readNotification = (payload) => AxiosRequest.post(
    `/${route.productCatalog}/catalognodes/readNotification/read/notification`,
    payload
  )

NotificationService.totalUnreadNotifications = () => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/notification/get/notification/count/by/contactId`,
  )
  NotificationService.sendOtp = (payload) => AxiosRequest.post(
    `/${route.notification}/otp/send`,
    payload
  )

  // NotificationService.verifyOtp = (payload) => postService(
  //   `/${route.notification}/otp/auth`,
  //   payload
  // )
  NotificationService.verifyOtp = (payload) => AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/verify/mobile/otp`,
    payload
  )
export default NotificationService;